/**
 * @generated SignedSource<<eb9b1607a495e8644034d8ba82162e98>>
 * @relayHash 8c0581f5679078b9db621f65a8d8c870
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2792b415d84d039e9fa1c4336883379f31f0eec977f272d7de9c640157dfd8a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e2792b415d84d039e9fa1c4336883379f31f0eec977f272d7de9c640157dfd8a",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
